<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="BlogFeaturedGroupComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

      <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BlogFeaturedGroupComponent'>
        <img src="static/images/icons/engrenagem.svg"
             class="svg-icon normal-action"
             @click="openPopupChoose"/>
      </options-element-bar>

        <div v-if="internal_config.articles.length > 0">
          <div class="container">
            <div class="row row-cheetah" style="justify-content: space-between">
              <card-post-simple v-for="article in internal_config.articles" :key="article.id" class="mt-3" style="width: 49%;" :config="internal_config" :article="article"></card-post-simple>
            </div>
          </div>

        </div>
        <div v-else>
          <div style="background-color: white; height: 300px; width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column">
            <h6 class="text-center">{{ $t('ct-no-articles-selected') }}</h6>
            <span>{{ $t('ct-helper-select-valid-filter') }}</span>
          </div>
        </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import elementData from './Model';
import OptionsElementBar from '../../OptionsElementBar';
import Resources from '../Generic/Resources/AppsWithArticlesResource';
import _ from 'lodash';
import CardPostSimple from '../Generic/PostCards/Simple';
import { getFilteredNews } from '../../../../../js/services/editor/blog.js';

export default {
  name: 'BlogFeaturedGroupComponent',
  props: ['config', 'id'],
  components: { OptionsElementBar, Resources, CardPostSimple },
  data() {
    return elementData.data();
  },
  methods: {
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    build(config) {
      console.log(config);
      this.internal_config = _.merge(this.internal_config, config);
    },
    animation() {
      return false;
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    callbackConfig(data) {
      console.log(data);
      this.internal_config.filters = data.filters;
      this.internal_config.showConfig = data.showConfig;
      this.getNews();
    },
    openPopupChoose() {
      this.$root.$emit('openBlogSettingsModal', _.clone(this.internal_config), this.$options.name, this.callbackConfig);
    },
    getNews() {
      getFilteredNews({
        category: this.internal_config.filters.category,
        author: this.internal_config.filters.author,
        featured: this.internal_config.filters.featured,
        mostAccessed: this.internal_config.filters.mostAccessed,
        amount: this.internal_config.filters.amount
      })
        .then(({data}) => {
          data.success ? this.internal_config.articles = data.data : console.log('error news');
        });
      // if (this.internal_config.article.id === 0) { return 0 }
      //
      // let vm = this;
      // getNewByID(this.internal_config.article.id)
      //   .then(({data}) => {
      //     if (data.success) {
      //       let article = data.data;
      //       vm.internal_config.article.title = article.title;
      //       vm.internal_config.article.content = article.content;
      //       vm.internal_config.article.summary = article.content;
      //       vm.internal_config.article.scheduled_date = article.scheduled_date;
      //       vm.internal_config.article.author = article.author;
      //       vm.internal_config.article.categories = article.categories;
      //       vm.internal_config.article.thumbnail = article.thumbnail;
      //     }
      //   });
    },
    article() {
      return this.internal_config.article;
    },
    style() {
      return `width: ${this.internal_config.width};
               height:  ${this.internal_config.height};
               z-index: ${this.internal_config.zIndex};
               margin: 0 auto;
               padding-top: ${this.internal_config.paddingTop};
               padding-left: ${this.internal_config.paddingLeft};
               padding-right: ${this.internal_config.paddingRight};
               padding-bottom: ${this.internal_config.paddingBottom};
               left:  ${this.internal_config.left};
               top: ${this.internal_config.top}`;
    },
    styleCard() {
      return `background-color: ${this.internal_config.backgroundColor};
      padding: 15px`;
    }
  },
  mounted() {
    this.build(this.$props.config);
    this.$refs.resourcesData.setValuesData(this);
    this.getNews();
  }
};
</script>

<style>

  [element="BlogFeaturedGroupComponent"] .vdr {
    height: auto !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/FeaturedGroup/FeaturedGroup.vue